import { createTheme } from "@mui/material/styles";
import { IPD_COLORS, IPD_SHAPE } from "./ipdColors";
import {
  getIpdSelectMenuProps,
  ipdElevatedInputSx,
  ipdLabelSx,
} from "./ipdFieldStyles";

export { IPD_COLORS, ADMISSION_COLORS, IPD_SHAPE, IPD_SPACING, IPD_TYPOGRAPHY } from "./ipdColors";
export {
  ipdPageSx,
  ipdCardSx,
  ipdPanelHeaderSx,
  ipdSelectedSx,
  ipdSemanticSx,
} from "./ipdColors";

/**
 * MUI theme for IPD module screens (admission, billing, etc.).
 * Wrap screen root in ThemeProvider with this theme.
 */
export function createIpdTheme() {
  const C = IPD_COLORS;
  const R = IPD_SHAPE.radiusMd;

  return createTheme({
    palette: {
      primary: {
        main: C.primary,
        dark: C.primaryDark,
        light: C.primaryLight,
        contrastText: C.white,
      },
      background: { default: C.pageBg, paper: C.cardBg },
      divider: C.border,
      text: { primary: C.textPrimary, secondary: C.textSecondary },
      success: { main: C.success.text, light: C.success.bg },
      warning: { main: C.warning.text, light: C.warning.bg },
      error: { main: C.error.text, light: C.error.bg },
      info: { main: C.info.text, light: C.info.bg },
    },
    shape: { borderRadius: R },
    typography: {
      h5: { fontWeight: 700, color: C.textPrimary },
      subtitle1: { fontWeight: 600, color: C.textPrimary },
      subtitle2: { fontWeight: 600, color: C.textPrimary },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: "none", fontWeight: 600, borderRadius: R },
          contained: { boxShadow: "none", "&:hover": { boxShadow: C.shadow.cardHover } },
          outlined: { borderColor: C.border, color: C.textPrimary },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: R,
            border: `1px solid ${C.border}`,
            boxShadow: C.shadow.card,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          colorPrimary: { backgroundColor: C.primary, color: C.white },
          outlined: { borderColor: C.border },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            border: `1px solid ${C.border}`,
            borderRadius: `${R}px !important`,
            boxShadow: C.shadow.card,
            "&:before": { display: "none" },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: { borderRadius: R, border: `1px solid ${C.border}` },
        },
      },
      MuiTextField: {
        defaultProps: {
          SelectProps: {
            MenuProps: getIpdSelectMenuProps(),
          },
        },
        styleOverrides: {
          root: ipdElevatedInputSx,
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: ipdLabelSx,
        },
      },
    },
  });
}

/** @deprecated Use createIpdTheme */
export const createAdmissionTheme = createIpdTheme;
